/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".horizontal-separator[_ngcontent-%COMP%]{height:0;width:90vw;max-width:1150px;margin:50px auto auto;background:linear-gradient(to right,rgba(255,255,255,0) 0,#dfdfdf 5%,#dfdfdf 95%,rgba(255,255,255,0) 100%)}.wdw.horizontal-separator[_ngcontent-%COMP%]{height:1px}@media screen and (min-width:975px){.horizontal-separator[_ngcontent-%COMP%]{height:1px}.wdw.horizontal-separator[_ngcontent-%COMP%]{height:0}}"];
export { styles as styles };
